import { ShipBuilderState } from "../../types/ship";
import { SHIP_BUILDER_STEPS, ShipBuilderStepId } from "../../constants/ship";
import { validateStepAccessibility } from "./stepValidation";

/**
 * Gets the next valid step in the ship building process
 * @param state - The current ship builder state
 * @param currentStep - The current step
 * @returns The next valid step or null if at the end
 */
export const getNextValidStep = (
  state: ShipBuilderState,
  currentStep: ShipBuilderStepId,
): ShipBuilderStepId | null => {
  const steps = SHIP_BUILDER_STEPS;
  const currentIndex = steps.findIndex((step) => step.id === currentStep);

  if (currentIndex === -1 || currentIndex === steps.length - 1) {
    return null;
  }

  // Find the next step that is accessible
  for (let i = currentIndex + 1; i < steps.length; i++) {
    const step = steps[i];
    const validation = validateStepAccessibility(state, step.id);
    if (validation.isValid) {
      return step.id;
    }
  }

  return null;
};

/**
 * Gets the previous valid step in the ship building process
 * @param state - The current ship builder state
 * @param currentStep - The current step
 * @returns The previous valid step or null if at the beginning
 */
export const getPreviousValidStep = (
  state: ShipBuilderState,
  currentStep: ShipBuilderStepId,
): ShipBuilderStepId | null => {
  const steps = SHIP_BUILDER_STEPS;
  const currentIndex = steps.findIndex((step) => step.id === currentStep);

  if (currentIndex <= 0) {
    return null;
  }

  // Find the previous step that is accessible
  for (let i = currentIndex - 1; i >= 0; i--) {
    const step = steps[i];
    const validation = validateStepAccessibility(state, step.id);
    if (validation.isValid) {
      return step.id;
    }
  }

  return null;
};
